module.exports = __webpack_public_path__ + "static/media/2019-MAT Survey Results.268fee61.pdf";